/* Lodestar geo-suggest: one-time country suggestion toast.
   Reads same-origin /browsing_context_suggestions.json and offers to switch
   market when the detected country differs from the active one. Copy and the
   ISO->currency map come from the #lodestar-geo-suggest mount node rendered
   in layout/theme.liquid. Fails silently on any error. */
(function () {
  'use strict';

  var LS_KEY = 'lodestar:loc';
  var SS_KEY = 'lodestar:loc-seen';

  function storageGet(area, key) {
    try { return window[area].getItem(key); } catch (error) { return null; }
  }
  function storageSet(area, key, value) {
    try { window[area].setItem(key, value); } catch (error) { /* private mode */ }
  }
  function persistChoice(choice, country) {
    storageSet('localStorage', LS_KEY, JSON.stringify({ choice: choice, country: country || null, ts: Date.now() }));
  }

  // Any manual localization form submit (header panel, drawer, footer) is an
  // explicit choice: record it so the toast never second-guesses the user.
  document.addEventListener('submit', function (event) {
    var action = event.target && typeof event.target.action === 'string' ? event.target.action : '';
    if (action.indexOf('/localization') > -1) persistChoice('manual', null);
  }, true);

  var mount = document.getElementById('lodestar-geo-suggest');
  if (!mount || navigator.webdriver) return;
  if (storageGet('localStorage', LS_KEY) || storageGet('sessionStorage', SS_KEY)) return;

  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true', {
    headers: { Accept: 'application/json' },
  })
    .then(function (response) { return response.ok ? response.json() : null; })
    .then(function (data) {
      var detected = data?.suggestions?.[0]?.parts?.country;
      var handle = detected?.handle;
      if (!handle || handle === mount.dataset.currentCountry) return;
      if (!detected.options || !(handle in detected.options)) return;
      if (!(detected.confidence >= 0.9)) return;
      var localName = '';
      try { localName = JSON.parse(mount.dataset.countryNames || '{}')[handle] || ''; } catch (error) { /* keep '' */ }
      showToast(handle, localName || detected.options[handle]);
    })
    .catch(function () { /* offline / blocked / non-JSON: no toast */ });

  function fill(template, country, currency) {
    return (template || '').split('[country]').join(country).split('[currency]').join(currency);
  }

  function consentOffset(toast) {
    var banner = document.getElementById('shopify-pc__banner');
    var height = banner ? banner.getBoundingClientRect().height : 0;
    toast.style.setProperty('--lodestar-toast-offset', height > 0 ? Math.round(height) + 16 + 'px' : '0px');
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function showToast(handle, countryName) {
    var currency = '';
    try { currency = JSON.parse(mount.dataset.currencies || '{}')[handle] || ''; } catch (error) { /* keep '' */ }
    storageSet('sessionStorage', SS_KEY, '1');

    var toast = element('div', 'lodestar-geo-toast');
    toast.setAttribute('role', 'status');
    toast.appendChild(element('p', 'lodestar-geo-toast__heading', fill(mount.dataset.heading, countryName, currency)));
    toast.appendChild(element('p', 'lodestar-geo-toast__body', fill(mount.dataset.body, countryName, currency)));

    var onDocClick = function () {
      if (toast.isConnected) consentOffset(toast);
    };
    // ESC closes the toast (session guard already set above keeps it away for
    // the rest of the session; no permanent persist for a reflexive ESC).
    var onKeydown = function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') removeToast();
    };
    function removeToast() {
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKeydown);
      toast.remove();
    }

    var actions = element('div', 'lodestar-geo-toast__actions');
    var accept = element('button', 'lodestar-geo-toast__accept', fill(mount.dataset.accept, countryName, currency));
    accept.type = 'button';
    accept.addEventListener('click', function () {
      persistChoice('switched', handle);
      removeToast();
      submitSwitch(handle);
    });
    var dismiss = element('button', 'lodestar-geo-toast__dismiss', mount.dataset.dismiss || '');
    dismiss.type = 'button';
    dismiss.addEventListener('click', function () {
      persistChoice('dismissed', handle);
      removeToast();
    });
    actions.appendChild(accept);
    actions.appendChild(dismiss);
    toast.appendChild(actions);
    document.body.appendChild(toast);

    // Keep clear of the consent banner (it mounts async and closes on click).
    consentOffset(toast);
    setTimeout(function () { consentOffset(toast); }, 2000);
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKeydown);
  }

  function submitSwitch(handle) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = mount.dataset.localizationUrl || '/localization';
    var fields = {
      form_type: 'localization',
      utf8: '✓',
      _method: 'put',
      country_code: handle,
      return_to: window.location.pathname + window.location.search,
    };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }
})();
